var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form-model",
        {
          staticClass: "big_box",
          attrs: {
            form: _vm.form,
            rules: _vm.rules,
            "label-col": { span: 2 },
            "wrapper-col": { span: 6 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "small_box" },
            [
              _c(
                "a-form-item",
                { attrs: { label: "SOP名称", required: true } },
                [
                  _c("a-input", {
                    attrs: { maxLength: 30, placeholder: "请输入SOP名称" },
                    model: {
                      value: _vm.entity.sopName,
                      callback: function ($$v) {
                        _vm.$set(_vm.entity, "sopName", $$v)
                      },
                      expression: "entity.sopName",
                    },
                  }),
                ],
                1
              ),
              _c("a-row", { attrs: { gutter: 24 } }, [
                _c("div", { staticClass: "ant-row ant-form-item" }, [
                  _c(
                    "div",
                    { staticClass: "ant-col ant-col-2 ant-form-item-label" },
                    [
                      _c("label", { staticClass: "ant-form-item-required" }, [
                        _vm._v("选择执行员工"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ant-col ant-col-6 ant-form-item-control-wrapper",
                    },
                    [
                      _c("userPickerWithNoParents", {
                        ref: "userPickerWithNoParents",
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "选择执行客户",
                            "label-col": { span: 2 },
                            "wrapper-col": { span: 7 },
                            required: true,
                          },
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.value,
                                callback: function ($$v) {
                                  _vm.value = $$v
                                },
                                expression: "value",
                              },
                            },
                            [
                              _c("a-radio", { attrs: { value: 2 } }, [
                                _vm._v(" 全部客户 "),
                              ]),
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v(" 筛选客户 "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.value === 1
                ? _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "营销内容标签",
                                "label-col": { span: 2 },
                                "wrapper-col": { span: 7 },
                                required: false,
                              },
                            },
                            [
                              _c("TagPicker", {
                                model: {
                                  value: _vm.custTagIds,
                                  callback: function ($$v) {
                                    _vm.custTagIds = $$v
                                  },
                                  expression: "custTagIds",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.value === 1
                ? _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "客户属性",
                                "label-col": { span: 2 },
                                "wrapper-col": { span: 7 },
                                required: false,
                              },
                            },
                            [
                              _vm.isLoaded
                                ? _c("customerAttributes", {
                                    model: {
                                      value: _vm.custNatureNames,
                                      callback: function ($$v) {
                                        _vm.custNatureNames = $$v
                                      },
                                      expression: "custNatureNames",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "small_two_box" }, [
            _c(
              "div",
              { staticClass: "small_two_left small_box_same" },
              [
                _vm._l(_vm.timeStr, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "data_box",
                      class: { active: index === _vm.indexAgain },
                      on: {
                        click: function ($event) {
                          return _vm.changeIndex(index)
                        },
                      },
                    },
                    [_c("div", [_vm._v(_vm._s(item))])]
                  )
                }),
                _c(
                  "a-button",
                  {
                    staticClass: "add_to",
                    attrs: { type: "dashed" },
                    on: {
                      click: function ($event) {
                        return _vm.addSendData(null)
                      },
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "plus" } }),
                    _vm._v(" 添加发送时间 "),
                  ],
                  1
                ),
              ],
              2
            ),
            _c("div", { staticClass: "small_two_right" }, [
              _c(
                "div",
                { staticClass: "small_time_box small_box_same" },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c("a-form-item", {
                        staticStyle: { "margin-bottom": "0!important" },
                        attrs: {
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 2 },
                          label: "发送时间",
                          required: true,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "fix" },
                    [
                      _c("a-date-picker", {
                        staticClass: "l",
                        staticStyle: { width: "30%", "margin-right": "5px" },
                        attrs: {
                          "show-time": "",
                          placeholder: "请选择日期",
                          "disabled-date": _vm.disabledDate,
                          defaultValue: _vm.moment(
                            _vm.nowTime,
                            "YYYY-MM-DD hh:mm:ss"
                          ),
                        },
                        on: { change: _vm.onChangeTime, ok: _vm.onOk },
                        model: {
                          value: _vm.changeTime,
                          callback: function ($$v) {
                            _vm.changeTime = $$v
                          },
                          expression: "changeTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "small_data_box small_box_same" }, [
                _c(
                  "div",
                  { staticClass: "send_content" },
                  [
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          {
                            staticStyle: { width: "43%!important" },
                            attrs: { span: 24 },
                          },
                          [
                            _c("a-form-item", {
                              attrs: {
                                "label-col": { span: 5 },
                                label: "发送内容",
                                required: true,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { staticClass: "fix", attrs: { span: 10 } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "upload_box fix",
                                staticStyle: {
                                  cursor: "pointer",
                                  float: "right",
                                },
                              },
                              [
                                _c(
                                  "a-tooltip",
                                  {
                                    staticClass: "l",
                                    attrs: { placement: "left" },
                                  },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(" 最多添加九个附件！ "),
                                    ]),
                                    _c("img", {
                                      staticClass: "img_box",
                                      attrs: {
                                        src: require("@/assets/img/fill.png"),
                                        alt: "",
                                      },
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "l btn_box" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { disabled: _vm.noClick },
                                        on: { click: _vm.showTextModal },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "15px",
                                            },
                                          },
                                          [_vm._v("+")]
                                        ),
                                        _vm._v("文本 "),
                                      ]
                                    ),
                                    _c(
                                      "a-modal",
                                      {
                                        attrs: {
                                          title: "请输入文本",
                                          "ok-text": "确认",
                                          "cancel-text": "取消",
                                        },
                                        on: {
                                          ok: _vm.hideModal,
                                          cancel: _vm.cancelModal,
                                        },
                                        model: {
                                          value: _vm.visible,
                                          callback: function ($$v) {
                                            _vm.visible = $$v
                                          },
                                          expression: "visible",
                                        },
                                      },
                                      [
                                        _c("a-textarea", {
                                          staticStyle: {
                                            "min-height": "100px",
                                          },
                                          model: {
                                            value: _vm.wordData,
                                            callback: function ($$v) {
                                              _vm.wordData = $$v
                                            },
                                            expression: "wordData",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-upload",
                                      {
                                        staticStyle: { "margin-left": "6px" },
                                        attrs: {
                                          headers: _vm.headers,
                                          accept: "image/*",
                                          name: "file",
                                          multiple: true,
                                          action:
                                            _vm.api.temp.WX_UPLOAD_PATH +
                                            "?uploadType=2",
                                          showUploadList: false,
                                        },
                                        on: { change: _vm.handleChange },
                                      },
                                      [
                                        _c(
                                          "a-button",
                                          { attrs: { disabled: _vm.noClick } },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "upload" },
                                            }),
                                            _vm._v(" 图片 "),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-upload",
                                      {
                                        staticStyle: { "margin-left": "6px" },
                                        attrs: {
                                          headers: _vm.headers,
                                          accept: "video/*",
                                          name: "file",
                                          multiple: true,
                                          action:
                                            _vm.api.temp.WX_UPLOAD_PATH +
                                            "?uploadType=3",
                                          showUploadList: false,
                                        },
                                        on: { change: _vm.handleChangeVideo },
                                      },
                                      [
                                        _c(
                                          "a-button",
                                          { attrs: { disabled: _vm.noClick } },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "upload" },
                                            }),
                                            _vm._v(" 视频 "),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "6px" },
                                        attrs: { disabled: _vm.noClick },
                                        on: { click: _vm.showLinkModal },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "15px",
                                            },
                                          },
                                          [_vm._v("+")]
                                        ),
                                        _vm._v("链接 "),
                                      ]
                                    ),
                                    _c(
                                      "a-modal",
                                      {
                                        attrs: {
                                          title: "请输入链接信息",
                                          "ok-text": "确认",
                                          "cancel-text": "取消",
                                        },
                                        on: {
                                          ok: _vm.hideModalLink,
                                          cancel: _vm.cancelModalLink,
                                        },
                                        model: {
                                          value: _vm.has,
                                          callback: function ($$v) {
                                            _vm.has = $$v
                                          },
                                          expression: "has",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "链接标题",
                                              "label-col": { span: 4 },
                                              "wrapper-col": { span: 20 },
                                              required: true,
                                            },
                                          },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                maxLength: 30,
                                                placeholder:
                                                  "请输入链接标题（必填）",
                                              },
                                              model: {
                                                value: _vm.linkTitle,
                                                callback: function ($$v) {
                                                  _vm.linkTitle = $$v
                                                },
                                                expression: "linkTitle",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "链接地址",
                                              "label-col": { span: 4 },
                                              "wrapper-col": { span: 20 },
                                              required: true,
                                            },
                                          },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                maxLength: 200,
                                                placeholder:
                                                  "请输入http或https开头的链接地址（必填）",
                                              },
                                              model: {
                                                value: _vm.linkAddress,
                                                callback: function ($$v) {
                                                  _vm.linkAddress = $$v
                                                },
                                                expression: "linkAddress",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "内容简介",
                                              "label-col": { span: 4 },
                                              "wrapper-col": { span: 20 },
                                            },
                                          },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                maxLength: 30,
                                                placeholder:
                                                  "请输入内容简介（选填）",
                                              },
                                              model: {
                                                value: _vm.linkContent,
                                                callback: function ($$v) {
                                                  _vm.linkContent = $$v
                                                },
                                                expression: "linkContent",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "链接图片",
                                              "label-col": { span: 4 },
                                              "wrapper-col": { span: 20 },
                                              required: true,
                                            },
                                          },
                                          [
                                            _c("uploader", {
                                              attrs: {
                                                num: 1,
                                                accept: "image/*",
                                                url: _vm.api.temp.UPLOAD_PATH,
                                                limitSize: 2,
                                              },
                                              model: {
                                                value: _vm.linkImgUrl,
                                                callback: function ($$v) {
                                                  _vm.linkImgUrl = $$v
                                                },
                                                expression: "linkImgUrl",
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { color: "#999" },
                                              },
                                              [
                                                _vm._v(
                                                  "必传，推荐尺寸160*160，支持jpg、png格式，不超过2M"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "data_show" },
                  _vm._l(_vm.dataInfo, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "hover_change fix",
                        on: {
                          mouseenter: function ($event) {
                            return _vm.onmouseover(index)
                          },
                          mouseleave: _vm.onmouseout,
                        },
                      },
                      [
                        item.typeId === 0
                          ? _c("div", { staticClass: " pr" }, [
                              _c("div", { staticClass: "l" }, [
                                _vm._v(_vm._s(item.text)),
                              ]),
                              _vm.have === index
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "r svg_btn",
                                      staticStyle: { top: "8px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteWord(
                                            item.text,
                                            item.contentId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "delete" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        item.typeId === 1
                          ? _c("div", { staticClass: "img_show fix pr" }, [
                              _c("div", { staticClass: "l" }, [
                                _c("img", {
                                  staticClass: "img_data",
                                  attrs: {
                                    src: _vm.api.temp.FILE_PATH + item.picUrl,
                                    alt: "",
                                  },
                                }),
                              ]),
                              _vm.have === index
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "r svg_btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteImg(
                                            item.picUrl,
                                            item.contentId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "delete" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        item.typeId === 2
                          ? _c("div", { staticClass: "img_show fix pr" }, [
                              _c("div", { staticClass: "l" }, [
                                _c("video", {
                                  ref: "singleVideo",
                                  refInFor: true,
                                  staticClass: "video-js",
                                  attrs: {
                                    src: _vm.api.temp.FILE_PATH + item.videoUrl,
                                    autoplay: "",
                                    controls: "",
                                  },
                                }),
                              ]),
                              _vm.have === index
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "r svg_btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteVideo(
                                            item.videoUrl,
                                            item.contentId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "delete" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        item.typeId === 3
                          ? _c("div", { staticClass: "fix pr" }, [
                              _c("div", { staticClass: "l" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link_box",
                                    attrs: {
                                      href: item.linkUrl,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("p", { staticClass: "name" }, [
                                      _vm._v(_vm._s(item.linkName)),
                                    ]),
                                    _c("p", { staticClass: "other" }, [
                                      _c("span", { staticClass: "intro" }, [
                                        _vm._v(_vm._s(item.linkContent)),
                                      ]),
                                      _c("img", {
                                        staticClass: "img",
                                        attrs: {
                                          src:
                                            _vm.api.temp.FILE_PATH +
                                            item.linkImgUrl,
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm.have === index
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "r svg_btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteLink(
                                            item.linkUrl,
                                            item.contentId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "delete" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveInfo } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }